export enum LighterTypeEnum {
    Red = 'red',
    Yellow = 'yellow',
    Green = 'green',
    Overdue = 'overdue',
}
